import React, { useEffect,useState } from "react";
import { RETURNS_UI_URLS, SEND_EMAIL_URL } from "../../../constants";
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { FormControl,OutlinedInput } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';


function EmailDialog(props){
    const [data1, setRetailerData] = React.useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const [radiovalue, setRadioValue] = React.useState('orderplacedemail'); 
    const isValidEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const [emailValid, setEmailValid] = useState(false);
    const[isResponse , setIsResponse] = useState(false);
    const [emailvalue, setEmailValue] = React.useState('');
    const [confirmEmailValue , setConfirmEmailValue]=React.useState('');
    const [emailverified, setEmailVerified] = React.useState(false);
    const { onClose, open } = props;
    const handleClose = ( isChecked ) => {
      setIsResponse(false);
      onClose(isChecked)
      setEmailValue('');
      setRadioValue('orderplacedemail');
      setConfirmEmailValue('');
      setErrorMessages({ name: "email", message: null });
    };

    useEffect(()=>{
      setIsResponse(false);
      setRadioValue('orderplacedemail');
      setErrorMessages({ name: "email", message: null });
      setRetailerData(JSON.parse(sessionStorage.getItem('retailerData')));
    },[])

   const handleSetValue = (value) =>{
        setIsResponse(false);
        setEmailValue('');
        setConfirmEmailValue('');
        setErrorMessages({ name: "email", message: null });
        setRadioValue(value);
    }

    const emailChange = (event) => {
        setEmailValue(event.target.value);
        if(event.target?.value && isValidEmail.test(event.target?.value)){
          setEmailValid(true);
          if(event.target.value === confirmEmailValue){
            setEmailVerified(true);
            setErrorMessages({ name: "Email", message: 'Email matched' });
          }
          else{
            if(emailvalue && confirmEmailValue){
              setErrorMessages({ name: "Email", message: 'Email not matched' });
            }
            else{
              setErrorMessages({ name: "Email", message: null });
            }
            setEmailVerified(false);
            }
          setIsResponse(false);
        }else{
          setErrorMessages({ name: "Email", message: 'Please provide correct email format' });
          setEmailValid(false);
          setEmailVerified(false);

        }
      }
    const confirmEmail =  (event) =>{
        setConfirmEmailValue(event.target.value);
        if(event.target?.value && isValidEmail.test(event.target?.value)){
           setEmailValid(true);
           if(event.target.value === emailvalue){
            setEmailVerified(true);
            setErrorMessages({ name: "confirmemail", message: 'Email matched' });
           }
           else{
            if(emailvalue && confirmEmailValue){
              setErrorMessages({ name: "confirmemail", message: 'Email not matched' });
            }
            else{
              setErrorMessages({ name: "confirmemail", message: null });
            }
            setEmailVerified(false);
          }
        }
        else{
          setErrorMessages({ name: "confirmemail", message: 'Please provide correct email format' });
            setEmailValid(false);
            setEmailVerified(false);
        }
    }

     const sendEmail = async () => {
      setIsResponse(true);
      let email = '';
      if(radiovalue === 'otheremail'){
        email = emailvalue;
      }
      else{
        email = props?.emailData?.emailId;

      }      
       let d = {
         "return_id": props?.emailData?.returnId,
         "shipment_id": props?.emailData?.shipId,
         "event_type": "RETURN_APPROVED",
         "to_recipient": email
       }
        const response = await fetch(SEND_EMAIL_URL.URL + 'api/v2025/returns-notification', {
            method: 'POST',
            body: JSON.stringify(d),
            headers: {
                'Content-Type': 'application/json',
                'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId),
            }
        });        
        if (response?.status === 200) {
            // const result = await response?.json();
           let result = {
              'email':email,
              'response':await response.text()
            }
            // setSnackOpen(true);
            // setSnackbarProp({ style: 'success', msg: 'Notification sent to ' + result?.return_summary?.email_id });
            handleClose(result);
        }
        else{
          let result = {
              'email':email,
              'response':false
            }
          handleClose(result);
          setIsResponse(false);
        }
    } 	

    const renderErrorMessage = (name) =>
        name === errorMessages.name && (
          <span className={`f-12 mt-5px ${errorMessages.message === 'Email matched' ? 'success-color':'error-color'}`}>{errorMessages.message}</span>
        );
       

    return (
        <div>
        <Dialog open={open}>
          <DialogTitle  className="fw-500"><div className="row">
            <div className="col-10 col-md-11 col-lg-11"> Please select email to send return details</div>
            <div className="col-2 col-md-1 col-lg-1"> <ClearIcon className='cursor-pointer' onClick={() => handleClose(false)}/></div></div></DialogTitle>
          <DialogContent className="mt-10">
              <DialogContentText id="alert-dialog-description">
                <FormControl className="mb-10">
                <RadioGroup  name="row-radio-buttons-group" value={radiovalue} defaultValue={'orderplacedemail'}>
                <FormControlLabel value="orderplacedemail"  onClick={e => handleSetValue('orderplacedemail')} control={<Radio  sx={{'& .MuiSvgIcon-root': {fontSize: 20,},}} className={`${data1.type}`} />}   label={<span style={{ fontWeight: '400' }}>{props?.emailData?.emailId}</span>} className={`f-14 fw-400 ${data1.type}`}/>
                <FormControlLabel value="otheremail" onClick={e => handleSetValue('otheremail')} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 20,},}} className={`${data1.type}`} />} label={<span style={{ fontWeight: '400' }}>Other email</span>} className={`f-14 fw-400 ${data1.type}`} />
                </RadioGroup>
                </FormControl>
              </DialogContentText>
              {radiovalue === 'otheremail' ? <div className="input-field">
               <form className="mt-10 mb-10">
               <FormControl fullWidth sx={{ m: 1 }}>
                    <div className="text-start mb-5px  fw-500 f-14 required">Enter Email</div>
                                        <OutlinedInput className={`full-width p-10 br-5 login-border f-14 ${data1.type}`} sx={{'& ::placeholder':{fontSize:'12px'}}} placeholder="Enter Email"
                                            type="text" name="email" autoComplete="off" value={emailvalue} onChange={emailChange} required
                                            label="email"/>
                                    </FormControl>
                    <FormControl fullWidth sx={{ m: 1 }}>
                    <div className="text-start mb-5px mt-10 fw-500 f-14 required" disabled="!emailvalue">Confirm Email</div>
                                     <OutlinedInput type="text" autoComplete="off" name="confirmEmail"  placeholder="Confirm Email" sx={{'& ::placeholder':{fontSize:'12px'}}}
                                      className={`full-width p-10 br-5 login-border f-14 ${data1.type}`} value={confirmEmailValue} onChange={confirmEmail} required
                                      label="Confirm Email"/>
                                    {emailvalue && renderErrorMessage("Email")}
                                    {confirmEmailValue && renderErrorMessage("confirmemail")}
                                    </FormControl>
               </form>
              </div> :'' }
            </DialogContent>
          <DialogActions className="justify-content-center">
          <button onClick={() => handleClose(false)} className={`${data1?.type} tertiary-btn`}>Cancel</button>
          <button onClick={() => sendEmail()} disabled={isResponse || (radiovalue === 'otheremail' ? (!emailvalue || !confirmEmailValue || !emailValid || !emailverified) : false)} className={`${isResponse ? 'cursor-not-allowed op-5': 'cursor-pointer'} ${data1?.type ? data1.type+'-btn':''} ${ isResponse || (radiovalue === 'otheremail') ? ((!emailvalue ||  !confirmEmailValue || !emailValid || !emailverified )? 'cursor-not-allowed op-5': 'cursor-pointer'):''}`}>Send</button>
        </DialogActions>
        </Dialog>
        </div>
      );
    }
    EmailDialog.propTypes = {
      onClose: PropTypes.func.isRequired,
      open: PropTypes.bool.isRequired,
    };
    
    export default EmailDialog;